import type { FaireProductEntity } from "../../entity_types/product";

export const p_bam5masyah: FaireProductEntity = {
  token: "p_bam5masyah",
  type: "product",
  name: "Carry All Caddy Tote - Sand Only",
  brandToken: "b_exgm2ufkzq",
  brandName: "Gray Haus",
  imageUrl:
    "https://cdn.faire.com/fastly/4b54ec360a519055622b13d1ccba28efd32ed85450a21c7b645db1d09da7d6f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/005f4c4a371d8965a973418e19a50e8c0cb44648c9e4a2312d62805434e07582.jpeg",
    "https://cdn.faire.com/fastly/cc2ab98f2aef15edc161b9fa4349cc6e33d09d43a6c5f2236850ed388bddf504.jpeg",
  ],
  priceDollars: 34.75,
  description:
    "Picture yourself collecting the freshest finds at the farmer’s market or effortlessly putting together a lake day bag….\n\nThis versatile carry-all is up for any adventure - day at the rink, girls’ weekend, grocery getting, you name it. The Carry-All Caddy features a sturdy design and spacious interior with plenty of pockets for convenient organization on the go.\n\nFEATURES\nWipeable, water resistant nylon exterior and interior\nComfortably padded hand or shoulder straps\n3 interior mesh pockets\n3 exterior a lot pockets\nPremium Vegan leather bottom and trim\nCollapsible design for effortless storage",
  tags: [],
  msrpDollars: 57.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:29.092Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
